<template>
  <button :class="classes" :aria-label="$t('wizard.noRecommendationRestartButtonTitle')" @click="onClick">
    <icon name="reload" class="trbo-a-question-restart-button__icon" />
  </button>
</template>

<script>
// @flow

import Icon from '../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-question-restart-button': true,
        'trbo-a-question-restart-button--disabled': this.disabled
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped src="./question-restart-button.scss" />
